import { useState, type ReactNode } from 'react'
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from '@/components/feedback/toast'
import { AuthSessionProvider } from '@/lib/auth'
import { createQueryClient } from '@/lib/http'
import { ROUTER_FUTURE } from './routerFuture'

export function Providers({
  children,
  queryClient,
}: {
  children: ReactNode
  queryClient?: QueryClient
}) {
  const [client] = useState(() => queryClient ?? createQueryClient())
  return (
    <QueryClientProvider client={client}>
      <ToastProvider>
        <BrowserRouter future={ROUTER_FUTURE}>
          <AuthSessionProvider>{children}</AuthSessionProvider>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  )
}
